import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { cfGetConstantValue } from '../util/CSConstantUtil';
import CSCOBackdrop from './CSCOBackdrop';
import CSServiceUtil from '../util/CSServiceUtil';
import CSRequestUtil from '../util/CSRequestUtil';
import CSUtil from '../util/CSUtil';
import { fnGetForm } from '../util/CSLayoutUtil';

const mCSServiceUtil = CSServiceUtil.cfGetInstance();

const CSCOFullCalendar = (gProps) => {
    const [mEvents, setEvents] = useState([]);
    const [mShowBackdrop, setBackdrop]                           = useState(false);
    const [mEventService, setEventService]                       = useState(null);
    const [mSelectedEvent, setSelectedEvent]                     = useState(null);
    const [mSelectedDate, setSelectedDate]                       = useState(null);
    const [mDetailsFlag, setDetailsFlag]                         = useState(false);
    const [mDetailsForm, setDetailsForm]                         = useState(null);
    const [mDetailsFormTitle, setDetailsFormTitle]               = useState(null);
    const [mSelectedActionItemRefId, setSelectedActionItemRefId] = useState(null);

    const fnHandleDateClick = (arg) => {
        setSelectedDate(arg.date);
        let lSelectedEvent  = {}
        let lStartDateField = null;
        let lStartTimeField = null;
        let lEndDateField   = null;
        let lEndTimeField   = null;
        if(gProps.mFormProperties){
            for(let lInd=0; lInd<gProps.mFormProperties.length; lInd++){
                let lItem = gProps.mFormProperties[lInd];
                if(lItem.property_ === 'start_date_field_') {
                    lStartDateField = lItem.value_;
                }
                else if(lItem.property_ === 'start_time_field_') {
                    lStartTimeField = lItem.value_;
                }
                else if(lItem.property_ === 'end_date_field_') {
                    lEndDateField = lItem.value_;
                }
                else if(lItem.property_ === 'end_time_field_') {
                    lEndTimeField = lItem.value_;
                }
            }    
        }

        if(gProps.mFormItems){
            for(let lInd=0; lInd<gProps.mFormItems.length; lInd++){
                let lItem = gProps.mFormItems[lInd];
                if(lItem.constant_){
                    lSelectedEvent[lItem.data_field_] = cfGetConstantValue(lItem.constant_);
                }
                else if(lStartDateField && (lItem.data_field_ === lStartDateField)){
                    lSelectedEvent[lStartDateField] = arg.dateStr;
                }
                else if(lEndDateField && (lItem.data_field_ === lEndDateField)){
                    lSelectedEvent[lEndDateField] = arg.dateStr;
                }
                else {
                    lSelectedEvent[lItem.data_field_] = '';
                }
            }
        }

        setSelectedEvent(lSelectedEvent);
    };

    const fnHandleEventClick = (clickInfo) => {
        let lSelectedEvent = clickInfo.event.extendedProps.data; 
        setSelectedEvent(lSelectedEvent);
    };

    const fnProcessSearch = (lServiceCode) => {
        if(!lServiceCode){
            lServiceCode = mEventService;
        }

        let lCriteria = null;
        if(gProps.mFormCriteria) {
            for(let lInd=0; lInd<gProps.mFormCriteria.length; lInd++) {
                let lCriteriaItem = gProps.mFormCriteria[lInd];
                if(lCriteriaItem.default_criteria_field_) {                        
                    if(!lCriteria) {
                        lCriteria = {}
                    }
                    
                    lCriteria[lCriteriaItem.default_criteria_field_] = cfGetConstantValue(lCriteriaItem.value_);
                }
            }
        }

        if(lServiceCode && lCriteria) {
            setBackdrop(true);
            let lServiceObject = mCSServiceUtil.cfGetServiceObject(lServiceCode);
            if(lServiceObject) {
                let lRequestUtil = new CSRequestUtil('GET', lServiceCode, lServiceObject.type_, null, lServiceObject);
                lRequestUtil.cfSetRequestCriteria(lCriteria);
                lRequestUtil.cfProcessRequest((lResponse) => {
                        if(lResponse && lResponse.hasOwnProperty("collection_")) {
                            let lCollection = lResponse.collection_;
                            if(lCollection) {
                                let lEvents = [];
                                for(let lInd=0; lInd<lCollection.length; lInd++) {
                                    let lEventObj = {}
                                    lEventObj.id            = lCollection[lInd].id_;
                                    lEventObj.title         = lCollection[lInd].title_;
                                    lEventObj.start         = lCollection[lInd].start_;
                                    lEventObj.end           = lCollection[lInd].end_;
                                    lEventObj.description   = lCollection[lInd].description_;
                                    lEventObj.location      = lCollection[lInd].location_;
                                    lEventObj.allDay        = (lCollection[lInd].all_day_ === 'Y');
                                    lEventObj.data          = lCollection[lInd];

                                    lEvents.push(lEventObj);
                                }

                                setEvents(lEvents);
                                /*
                                if(mEvents) {
                                    setEvents(lPrevEvents => [...lPrevEvents, ...lEvents]);
                                }
                                else {
                                    setEvents(lPrevEvents => [...lPrevEvents, ...lEvents]);
                                } */
                            }
                        }

                        setBackdrop(false);
                    }
                );
            }
            else {                    
                setBackdrop(false);
            }
        }
    }
    const fnProcessClose = () => {
        setSelectedEvent(null);
        setDetailsFlag(false);
        setDetailsForm(null);
        fnProcessSearch();
    }

    useEffect(()=>
        {
            /**
             * Reset Events
             */
            setEvents([]);
            setSelectedEvent(null);
            setSelectedDate(null);
            setDetailsFlag(null);
            setDetailsForm(null);
            setDetailsFormTitle(null);
            setSelectedActionItemRefId(null);

            /**
             * Get Service Code and fetch Events
             */
            let lServiceCode = null;
            if(gProps.mFormProperties) {
                for(let lInd=0; lInd<gProps.mFormProperties.length; lInd++) {
                    let lProp = gProps.mFormProperties[lInd];
                    if ((lProp.type_ === 'initialize') && (lProp.property_ === 'service_code_')) {
                        lServiceCode = lProp.value_;
                        setEventService(lServiceCode);
                    }
                    else if ((lProp.type_ === 'initialize') && (lProp.property_ === 'selected_action_item_ref_id_')) {
                        setSelectedActionItemRefId(lProp.value_);
                    }
                    else if ((lProp.type_ === 'initialize') && (lProp.property_ === 'title_')) {
                        setDetailsFormTitle(lProp.value_);
                    }
                }
            }

            fnProcessSearch(lServiceCode);
        }, [gProps.feature_ref_id_]
    );

    useEffect(() => {
            let lActions = gProps.mFormActions;
            let lSelectedActionItem = null;
            if(lActions) {
                for(let lInd=0; lInd<lActions.length; lInd++){
                    if(lActions[lInd].id_ === mSelectedActionItemRefId) {
                        lSelectedActionItem = lActions[lInd];
                    }
                }
            }

            if(mSelectedEvent) {
                let lDetailsMetaData = {
                    pAppId                  : gProps.app_id_,
                    pFormType               : 'CS_DETAILS_FORM_1',
                    pFormHeading            : mDetailsFormTitle,
                    pFormActions            : (lActions) ? CSUtil.cfSort(lActions, 'sequence_') : null,
                    pFormProperties         : gProps.mFormProperties,
                    pFormItems              : gProps.mFormItems,
                    pFormItemProperties     : gProps.mFormItemProperties,
                    pFormValidation         : gProps.mFormValidation,
                    pFormMetaData           : gProps.mFormMetaData,
                    pSelectedData           : mSelectedEvent,
                    pFormData               : mSelectedEvent,
                    pSelectedActionItem     : lSelectedActionItem
                };
            
                let lDetailsForm = fnGetForm(lDetailsMetaData, mSelectedEvent, fnProcessClose);
                setDetailsFlag(true);
                setDetailsForm(lDetailsForm);
            }

        }, [mSelectedEvent]
    );

    return (
        <>
            <CSCOBackdrop pShow = {mShowBackdrop}/>
            <div className="calendar-container" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="calendar-wrapper">
                    <FullCalendar
                        plugins       = {[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                        initialView   = "dayGridMonth"
                        events        = {mEvents}
                        dateClick     = {fnHandleDateClick}
                        eventClick    = {fnHandleEventClick}
                        selectable    = {true}
                        headerToolbar = {{
                            left: 'prev,next today',
                            center: 'title',
                            right: 'dayGridMonth timeGridWeek timeGridDay'
                        }}
                        buttonText={{
                            today : 'Today',
                            month : 'Month',
                            week  : 'Week',
                            day   : 'Day'
                        }}
                        slotMinTime = "08:00:00"
                        slotMaxTime = "20:00:00"
                        allDaySlot  = {true}
                        height      = "auto"
                    />
                </div>
            </div>

            { (mDetailsFlag) ? mDetailsForm : null }
        </>
    );
};

export default CSCOFullCalendar;